import React, { useState } from 'react';
import { WppActionButton, WppIconVideoOn, WppModal } from '@wppopen/components-library-react';
import { CrossIcon, Main, Header, HeaderText } from './OnBoardingSectionStyles';
import ReactPlayer from 'react-player';
import { TestIds } from 'utils';

export const OnBoardingSection = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleVisibility = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <Main>
            <WppActionButton
                onClick={handleVisibility}
                data-testid={TestIds.projection.actions.videoGuideButton}
            >
                <WppIconVideoOn slot="icon-start" />
                Video Guide
            </WppActionButton>
            <WppModal
                open={isOpen}
                size="m"
                onWppModalClose={handleVisibility}
                data-testid={TestIds.projection.containers.videoGuide}
            >
                <Header slot="header" data-testid={TestIds.projection.containers.videoGuideTitle}>
                    <HeaderText type="m-strong">Video Guide</HeaderText>
                    <CrossIcon slot="icon-start" onClick={handleVisibility} />
                </Header>
                <ReactPlayer
                    url="https://storage.googleapis.com/training-239408/us-onboarding.mp4"
                    controls={true}
                    playing={isOpen}
                    width="100%"
                    height="100%"
                    slot="body"
                />
                <div slot="actions"></div>
            </WppModal>
        </Main>
    );
};
